/* Build Your Bay — one configurator, one /cart/add.js call.
   All prices/IDs come from the Liquid-rendered blob (live product data at
   request time), so nothing here knows a price until the page tells it. */
(function () {
  'use strict';

  var root = document.querySelector('[data-byb]');
  if (!root) return;

  var dataEl = root.querySelector('[data-byb-data]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var SIZE_KEYED = ['framing', 'backCover', 'backCoverPipe'];

  var state = {
    size: root.dataset.defaultSize,
    tier: root.dataset.defaultTier,
    mat: root.dataset.defaultMat,
    strip: root.dataset.defaultStrip,
    on: { framing: true, backCover: true, backCoverPipe: true, ironTees: true, teePack: true }
  };

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Resolve the variant currently selected for a parts-list row. */
  function variantFor(key) {
    if (key === 'enclosure') return DATA.enclosure[state.tier + '||' + state.size];
    if (key === 'mat') return DATA.mat[state.mat + '||' + state.strip];
    if (SIZE_KEYED.indexOf(key) !== -1) return (DATA[key] || {})[state.size];
    return DATA[key];
  }

  function variantLabelFor(key) {
    if (key === 'enclosure') return state.tier.replace(' Golf Impact', '') + ' · ' + state.size.replace(' x ', ' × ');
    if (key === 'mat') return state.mat.replace("Carl's ", '').replace(' HotShot™ Hitting Mat', '') + ' · ' + state.strip;
    if (SIZE_KEYED.indexOf(key) !== -1) return state.size.replace(' x ', ' × ');
    return '';
  }

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-byb-part]'));
  var REQUIRED = { enclosure: true, mat: true };

  function included(key) {
    return REQUIRED[key] === true || state.on[key] === true;
  }

  function render() {
    /* Back cover pipes only hang a back cover — keep the dependency honest. */
    var pipeToggle = root.querySelector('[data-byb-toggle="backCoverPipe"]');
    if (pipeToggle) {
      if (!state.on.backCover) {
        state.on.backCoverPipe = false;
        pipeToggle.checked = false;
        pipeToggle.disabled = true;
        pipeToggle.closest('.byb-toggle').title = 'Add the Back Cover Kit first';
      } else {
        pipeToggle.disabled = false;
        pipeToggle.closest('.byb-toggle').title = '';
      }
    }

    var lines = [];
    var total = 0;
    var blocked = null;

    rows.forEach(function (row) {
      var key = row.dataset.bybPart;
      var v = variantFor(key);
      var priceEl = row.querySelector('[data-byb-price]');
      var labelEl = row.querySelector('[data-byb-variant-label]');
      var oosEl = row.querySelector('[data-byb-oos]');
      var isIn = included(key);

      row.classList.toggle('byb-part--off', !isIn);
      if (labelEl) labelEl.textContent = variantLabelFor(key);

      if (!v) {
        if (priceEl) priceEl.textContent = '—';
        if (oosEl) oosEl.hidden = !isIn;
        if (isIn) blocked = blocked || 'One part in this build has no match for that size.';
        return;
      }

      if (priceEl) priceEl.textContent = money(v.price);
      if (oosEl) oosEl.hidden = !(isIn && v.available === false);
      if (isIn && v.available === false) blocked = blocked || 'One part in this build is out of stock right now.';

      if (isIn) {
        total += v.price;
        lines.push({ name: row.querySelector('.byb-part__name').textContent.trim(), price: v.price });
      }
    });

    /* Per-tier enclosure price at the current size, so the screen choice is priced honestly. */
    root.querySelectorAll('[data-byb-tier-price]').forEach(function (el) {
      var v = DATA.enclosure[el.dataset.bybTierPrice + '||' + state.size];
      el.textContent = v ? money(v.price) : '—';
    });

    var linesEl = root.querySelector('[data-byb-lines]');
    if (linesEl) {
      linesEl.innerHTML = lines.map(function (l) {
        return '<li><span></span><span></span></li>';
      }).join('');
      Array.prototype.forEach.call(linesEl.children, function (li, i) {
        li.children[0].textContent = lines[i].name;
        li.children[1].textContent = money(lines[i].price);
      });
    }

    var specEl = root.querySelector('[data-byb-spec]');
    if (specEl) {
      specEl.textContent = state.size.replace(' x ', ' × ') + ' · ' +
        state.tier.replace(' Golf Impact', '') + ' screen · ' +
        state.mat.replace("Carl's ", '').replace(' HotShot™ Hitting Mat', '') + ' mat';
    }

    root.querySelectorAll('[data-byb-total]').forEach(function (el) { el.textContent = money(total); });

    var countEl = root.querySelector('[data-byb-bar-count]');
    if (countEl) countEl.textContent = lines.length + (lines.length === 1 ? ' item' : ' items');

    var shipEl = root.querySelector('[data-byb-ship]');
    if (shipEl) shipEl.textContent = total >= DATA.freeShipThreshold ? 'Free shipping — included' : 'Shipping calculated at checkout';

    var errEl = root.querySelector('[data-byb-error]');
    root.querySelectorAll('[data-byb-add]').forEach(function (b) { b.disabled = !!blocked; });
    if (errEl) {
      errEl.hidden = !blocked;
      if (blocked) errEl.textContent = blocked;
    }
  }

  /* ── Radio groups ──────────────────────────────────────────────────── */
  function wireRadios(attr, stateKey) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[' + attr + ']'));
    els.forEach(function (el, i) {
      el.addEventListener('click', function () {
        state[stateKey] = el.getAttribute(attr);
        els.forEach(function (o) { o.setAttribute('aria-checked', String(o === el)); });
        render();
      });
      el.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
              : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = els[(i + d + els.length) % els.length];
        next.focus();
        next.click();
      });
    });
  }

  wireRadios('data-byb-size', 'size');
  wireRadios('data-byb-tier', 'tier');
  wireRadios('data-byb-mat', 'mat');
  wireRadios('data-byb-strip', 'strip');

  /* ── ?size= deep link ──────────────────────────────────────────────────
     The room-size calculator already knows the visitor's opening, so it can
     hand it straight to step 1. Only an EXACT match to a rendered step-1
     button counts — an unknown or missing value is a silent no-op that
     leaves the page in its normal default state. Never snap to a "nearest"
     size: an opening that does not fit their room is worse than no preset. */
  function applySizeFromQuery() {
    var raw;
    try {
      raw = new URLSearchParams(window.location.search).get('size');
    } catch (e) { return; }
    if (!raw) return;

    var want = raw.trim();
    var btn = null;
    root.querySelectorAll('[data-byb-size]').forEach(function (el) {
      if (!btn && el.getAttribute('data-byb-size') === want) btn = el;
    });
    if (!btn) return;

    btn.click();

    /* Step 1 is answered — put them on the next decision. */
    var step2 = document.getElementById('byb-step-2');
    var target = step2 ? step2.closest('.byb-step') : null;
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  root.querySelectorAll('[data-byb-toggle]').forEach(function (input) {
    input.addEventListener('change', function () {
      state.on[input.dataset.bybToggle] = input.checked;
      render();
    });
  });

  /* ── One add to cart ───────────────────────────────────────────────── */
  function addToCart(btn) {
    var items = [];
    rows.forEach(function (row) {
      var key = row.dataset.bybPart;
      if (!included(key)) return;
      var v = variantFor(key);
      if (v && v.available !== false) items.push({ id: v.id, quantity: 1 });
    });
    if (!items.length) return;

    var errEl = root.querySelector('[data-byb-error]');
    var labels = Array.prototype.slice.call(root.querySelectorAll('[data-byb-add-label]'));
    var prev = labels.map(function (l) { return l.textContent; });
    root.querySelectorAll('[data-byb-add]').forEach(function (b) { b.disabled = true; });
    labels.forEach(function (l) { l.textContent = 'Adding…'; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add your bay to the cart.');
        window.location.href = DATA.cartUrl || '/cart';
      })
      .catch(function (err) {
        root.querySelectorAll('[data-byb-add]').forEach(function (b) { b.disabled = false; });
        labels.forEach(function (l, i) { l.textContent = prev[i]; });
        if (errEl) { errEl.hidden = false; errEl.textContent = err.message; }
      });
  }

  root.querySelectorAll('[data-byb-add]').forEach(function (btn) {
    btn.addEventListener('click', function () { addToCart(btn); });
  });

  render();
  applySizeFromQuery();
})();
